import * as actionTypes from "./global-action-types";

export const setGlobalLanguageId = (languageId) => ({
    type: actionTypes.SET_GLOBAL_LANGUAGE_ID,
    payload: languageId
});
